const s = {
  name: "Wifi",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.6 32" style="enable-background:new 0 0 39.6 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.8,2C12.6,2,6.1,4.9,1.4,9.6L0,8.2C5.1,3.1,12.1,0,19.8,0s14.7,3.1,19.8,8.2l-1.4,1.4
			C33.5,4.9,27,2,19.8,2z"/>
		<path class="st0" d="M5.7,13.9C9.3,10.2,14.3,8,19.8,8s10.5,2.2,14.1,5.9l1.4-1.4c-4-4-9.5-6.4-15.6-6.4S8.2,8.5,4.2,12.4
			L5.7,13.9z"/>
		<path class="st0" d="M9.9,18.1c2.5-2.5,6-4.1,9.9-4.1s7.4,1.6,9.9,4.1l1.4-1.4c-2.9-2.9-6.9-4.7-11.3-4.7s-8.4,1.8-11.3,4.7
			L9.9,18.1z"/>
		<path class="st0" d="M19.8,20c-2.2,0-4.2,0.9-5.7,2.3l-1.4-1.4c1.8-1.8,4.3-2.9,7.1-2.9s5.3,1.1,7.1,2.9l-1.4,1.4
			C24,20.9,22,20,19.8,20z"/>
		<path class="st0" d="M17,25.2c0.7-0.7,1.7-1.2,2.8-1.2s2.1,0.5,2.8,1.2c0.7,0.7,1.2,1.7,1.2,2.8c0,2.2-1.8,4-4,4s-4-1.8-4-4
			C15.8,26.9,16.3,25.9,17,25.2z M19.8,26c-0.6,0-1.1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.1,0.9,2,2,2s2-0.9,2-2
			c0-0.6-0.2-1.1-0.6-1.4C20.8,26.2,20.3,26,19.8,26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Wifi
};
